// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanCreateWorkspace } from "./hook";

export type CanCreateWorkspaceProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanCreateWorkspace({
  children,
  fallback,
  scope,
}: CanCreateWorkspaceProps) {
  const canDoAction = useCanCreateWorkspace(scope);
  return <>{canDoAction ? children : fallback}</>;
}
